import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map, Observable, startWith } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UrlHelperService {
  private router: Router = inject(Router);

  /**
   * Returns an observable that emits true if the current URL matches the provided pattern.
   * @param urlPattern - The URL pattern to match against the current URL.
   *                    Can be exact path or just a prefix to check.
   * @param exact - If true, the URL must match exactly, if false, it checks if URL starts with the pattern
   */
  isRouteActive(urlPattern: string, exact: boolean = false): Observable<boolean> {
    return this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      startWith({ url: this.router.url } as NavigationEnd),
      map((event: NavigationEnd) => {
        const currentUrl = event.url.split('?')[0]; // Remove query params

        if (exact) {
          return currentUrl === urlPattern;
        } else {
          return currentUrl.startsWith(urlPattern);
        }
      }),
    );
  }
}
